import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "react-toastify";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../firebase";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      toast.error("Please enter your email.");
      return;
    }

    try {
      await sendPasswordResetEmail(auth, email);
      toast.success("Reset link sent. Check your inbox.");
      navigate("/login");
    } catch (err) {
      toast.error(err.message || "Something went wrong.");
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.leftPanel}>
        <div style={styles.card}>
          <h2 style={styles.title}>Forgot Your Password?</h2>
          <p style={styles.subtext}>
            Enter your email and we’ll send you a link to reset your password.
          </p>

          <form onSubmit={handleSubmit} style={styles.form}>
            <label htmlFor="email" style={styles.label}>Email Address</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              required
              style={styles.input}
              onFocus={(e) => (e.target.style.boxShadow = "0 0 0 3px rgba(143, 39, 255, 0.2)")}
              onBlur={(e) => (e.target.style.boxShadow = "none")}
            />

            <button
              type="submit"
              style={styles.primaryBtn}
              onMouseEnter={(e) => (e.target.style.backgroundColor = "#7320d8")}
              onMouseLeave={(e) => (e.target.style.backgroundColor = "#8F27FF")}
            >
              Send Reset Link
            </button>

            <p style={styles.footerText}>
              <Link to="/login" style={styles.link}>← Back to Login</Link>
            </p>
          </form>
        </div>
      </div>

      <div style={styles.rightPanel}>
        <div style={{ textAlign: "center", animation: "fadeIn 1.2s ease-out" }}>
          <h1 style={{ fontSize: 36, fontWeight: "bold", marginBottom: 20 }}>
            We’ve Got You!
          </h1>
          <p style={{ fontSize: 18, maxWidth: 400 }}>
            No worries. We'll send a password reset link to your email. You’ll be back in no time.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;

const styles = {
  container: {
    display: "flex",
    height: "100vh",
    overflow: "hidden",
    fontFamily: "'Inter', sans-serif",
  },
  leftPanel: {
    flex: 1,
    overflowY: "auto",
    backgroundColor: "#f9f9f9",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "2rem",
  },
  rightPanel: {
    flex: 1,
    background: "linear-gradient(to bottom right, #8F27FF, #200D41)",
    color: "#fff",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "2rem",
  },
  card: {
    background: "#fff",
    borderRadius: "16px",
    boxShadow: "0 6px 24px rgba(0,0,0,0.08)",
    width: "100%",
    maxWidth: "450px",
    padding: "2rem",
  },
  title: {
    fontSize: "26px",
    fontWeight: 700,
    color: "#200D41",
    marginBottom: "0.75rem",
    textAlign: "center",
  },
  subtext: {
    fontSize: "15px",
    color: "#555",
    marginBottom: "1.5rem",
    textAlign: "center",
  },
  form: {
    display: "flex",
    flexDirection: "column",
  },
  label: {
    marginBottom: "6px",
    fontWeight: 600,
    fontSize: "15px",
    color: "#333",
  },
  input: {
    padding: "12px 14px",
    marginBottom: "20px",
    borderRadius: "10px",
    border: "1.5px solid #d0cde1",
    fontSize: "15px",
    backgroundColor: "#fff",
    transition: "all 0.2s ease",
    outline: "none",
  },
  primaryBtn: {
    backgroundColor: "#8F27FF",
    color: "#fff",
    border: "none",
    padding: "14px",
    borderRadius: "10px",
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: 600,
    transition: "all 0.2s ease",
    marginTop: "12px",
  },
  link: {
    color: "#8F27FF",
    textDecoration: "none",
    fontWeight: 600,
  },
  footerText: {
    fontSize: "14px",
    color: "#444",
    textAlign: "center",
    marginTop: "20px",
  },
};
